import { SUPPORTED_COUNTRY_MAP, SupportedCountryCode } from './constants';

// The VME-4061 follow-up work that consolidated the driver licence country predicates: the
// editors that let someone change a licence's country of issue each carried their own copy of
// the three predicates below. The NZ/NZL fault in isDifferentCountryOfIssue was found once and
// had to be fixed three times, which is why they live here now instead. The admin editor
// (apps/admin-portal/.../DriverLicence/DriverLicenceEditor.tsx) and the composed customer-facing
// editor (packages/views/.../ComposedContextIdentityDocumentsWizard/OcrEditor/OcrEditor.tsx) both
// import from here. The legacy IdentityDocumentsWizard copy is left as-is: that tree is deleted
// by #2147.

export function isAustralianLicence(countryOfIssue: string | undefined): boolean {
  return countryOfIssue === SupportedCountryCode.AU || countryOfIssue === SupportedCountryCode.AUS;
}

/**
 * Whether two country-of-issue codes name different countries.
 *
 * `AU` and `AUS` are the same country written two ways - both reach this code, depending on whether
 * the value came from the authorised issuers API or from stored data - so a plain string comparison
 * would report a change of country where there is none and throw away the State the customer had
 * already chosen. SUPPORTED_COUNTRY_MAP carries both spellings of every supported country under one
 * label, which is the comparison this needs; a code the map does not know is compared as itself.
 */
export function isDifferentCountryOfIssue(previous: string, next: string): boolean {
  if (previous === next) return false;
  const nameOf = (code: string) =>
    SUPPORTED_COUNTRY_MAP[code as SupportedCountryCode]?.label ?? code;
  return nameOf(previous) !== nameOf(next);
}

export function isNewZealandLicence(countryOfIssue: string | undefined): boolean {
  return countryOfIssue === SupportedCountryCode.NZ || countryOfIssue === SupportedCountryCode.NZL;
}
